import BadgeIsValid from '~/components/BadgeIsValid'

const PanelIconLeft = ({
  costCpmIsValid,
  adsBelowMinCostCpmLength,
  costIsValid,
  adsBelowMinCostLength,
  adType
}: {
  costCpmIsValid: boolean
  adsBelowMinCostCpmLength: number
  costIsValid: boolean
  adsBelowMinCostLength: number
  adType: string
}) => {
  const showCpmBadge =
    !costCpmIsValid && !!adsBelowMinCostCpmLength && adType === 'banner'
  const showCpcBadge =
    !costIsValid && !!adsBelowMinCostLength && adType === 'product'

  if (!showCpmBadge && !showCpcBadge) return null

  return (
    <>
      {showCpmBadge && <BadgeIsValid isValid={!!costCpmIsValid} />}
      {showCpcBadge && <BadgeIsValid isValid={!!costIsValid} />}
    </>
  )
}

export default PanelIconLeft
